import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";

export const ThemeToggle = ({ theme, toggle }) => {
  return (
    <button
      data-testid="theme-toggle-button"
      onClick={toggle}
      aria-label="Toggle theme"
      className="relative h-10 w-10 grid place-items-center rounded-full border border-[var(--border-c)] bg-[var(--surface)] text-[var(--text)] hover:border-[var(--gold)] transition-colors duration-300"
    >
      <motion.span
        key={theme}
        initial={{ rotate: -40, opacity: 0, scale: 0.6 }}
        animate={{ rotate: 0, opacity: 1, scale: 1 }}
        transition={{ duration: 0.35 }}
        className="grid place-items-center"
      >
        {theme === "dark" ? (
          <Sun className="h-[18px] w-[18px] text-[var(--gold)]" />
        ) : (
          <Moon className="h-[18px] w-[18px] text-[var(--terracotta)]" />
        )}
      </motion.span>
    </button>
  );
};
